import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IMiscFormMeta {
    decimalizationTable: FormInputMeta;
    encryptedPinKey: FormInputMeta;
    secondIndexReferencePoint: FormInputMeta;

}

const miscFormMeta = {} as IMiscFormMeta;

miscFormMeta.decimalizationTable = {
    name: "decimalizationTable",
    type: "number",
    label: "Table de Décimalisation",
    placeholder: "",
    validation: yup.number()
};

miscFormMeta.encryptedPinKey = {
    name: "encryptedPinKey",
    type: "number",
    label: "Clé PIN Encryptée",
    placeholder: "",
    validation: yup.number()
};

miscFormMeta.secondIndexReferencePoint = {
    name: "secondIndexReferencePoint",
    type: "number",
    label: "Point Reférence 2nd Index",
    placeholder: "",
    validation: yup.number()
};


export default miscFormMeta;